import styled from 'styled-components'

import List from '../List'
import MenuItem from './MenuItem'

const Menu = styled(List)`
  &,
  ${MenuItem} {
    height: ${props => (props.inline ? '64px' : 'auto')};
  }

  ${MenuItem} {
    padding: 0 ${props => props.theme.gutter}px;
  }
`

export default Menu
